"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _tagsConfig = require("../tagsConfig");
const useTags = (namespaceArray, options) => {
  const ky = (0, _core.useOkapiKy)();
  const nsArray = namespaceArray ?? _tagsConfig.tagNamespaceArray;
  return (0, _reactQuery.useQuery)(nsArray, () => ky.get(_tagsConfig.defaultTagQuery).json(), options);
};
var _default = exports.default = useTags;